import tabs from './tabs';
import slider from './slider';
import accordion from './accordion';
import pageAnim from './pageAnim';

export {
  tabs,
  slider,
  accordion,
  pageAnim,
};
